(function () {
  const STORAGE_KEY = 'cart-reserved-until';

  class CartReservedBanner extends HTMLElement {
    connectedCallback() {
      this.durationMs = parseInt(this.dataset.durationMs || '300000', 10);
      this.timeEl = this.querySelector('[data-cart-reserved-time]');
      if (!this.timeEl) return;

      this.tick();
      this.intervalId = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    tick() {
      const now = Date.now();
      let until = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      if (!until || until < now) {
        until = now + this.durationMs;
        try {
          sessionStorage.setItem(STORAGE_KEY, String(until));
        } catch (e) {
          /* private mode */
        }
      }

      const msLeft = Math.max(0, until - now);
      const totalSec = Math.ceil(msLeft / 1000);
      const minutes = Math.floor(totalSec / 60);
      const seconds = totalSec % 60;
      this.timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
    }
  }

  if (!customElements.get('cart-reserved-banner')) {
    customElements.define('cart-reserved-banner', CartReservedBanner);
  }
})();
